import { observerEpicHelper, checkAuthorization, dispatchFlashMessage } from 'epics/helpers'
import { deleteCollection, duplicateCollection } from 'apis/private/collection'
import { Actions as PageActions } from 'actions/page'
import { Actions as ClipboardActions } from 'actions/utility/clipboard'
import { getUserID } from 'selectors/user/session'
import { Constants } from '../actions'
import Selectors from '../selectors'
import { getCollectionIdUserCollection } from '../selectors/collection'
import { getUserCollectionsUrl } from '../selectors/url'
const { SITE_URL } = process.env
export const createCollectionEpic = observerEpicHelper(
  [Constants.COLLECTION_ACTION_CREATE],
  async ({ action, observer, store }) => {
    if (checkAuthorization({ ...store.value })) {
      const { createUrl } = Selectors.getAdminUrlLinks({ ...store.value })
      window.location.href = createUrl
    }

    observer.complete()
  }
)
export const deleteCollectionEpic = observerEpicHelper(
  [Constants.COLLECTION_ACTION_DELETE],
  async ({ action, observer, store }) => {
    const idUserCollection = getCollectionIdUserCollection({ ...store.value })
    const collectionsUrl = getUserCollectionsUrl({ ...store.value })
    const confirmDeletion = confirm('Are you sure you want to delete this collection?')

    if (confirmDeletion) {
      observer.next(PageActions.IS_READY(false))
      const apiResponse = await deleteCollection(idUserCollection)
      const { success } = apiResponse

      if (!success) {
        dispatchFlashMessage({
          observer,
          message: 'Problem deleting collection',
          type: 'error',
        })
      } else {
        dispatchFlashMessage({
          observer,
          message: 'Successfully deleted collection',
          type: 'success',
        })
        observer.next(PageActions.IS_READY(false))
        window.location.href = collectionsUrl
      }
    }

    observer.complete()
  }
)
export const duplicateCollectionEpic = observerEpicHelper(
  [Constants.COLLECTION_ACTION_DUPLICATE],
  async ({ action, observer, store }) => {
    if (checkAuthorization({ ...store.value })) {
      const idUserCollection = getCollectionIdUserCollection({ ...store.value })
      const userId = getUserID({ ...store.value })
      observer.next(PageActions.IS_READY(false))
      const apiResponse = await duplicateCollection(idUserCollection)
      const { success, payload } = apiResponse
      const { newIdUserCollection } = payload

      if (!success) {
        dispatchFlashMessage({
          observer,
          message: 'Problem duplicating collection',
          type: 'error',
        })
      } else {
        dispatchFlashMessage({
          observer,
          message: 'Successfully duplicated collection',
          type: 'success',
        })
        observer.next(PageActions.IS_READY(false))
        const duplicateUrl = `/collections/edit/owner/${userId}/collection/${newIdUserCollection}`
        window.location.href = duplicateUrl
      }
    }

    observer.complete()
  }
)
export const editCollectionAction = observerEpicHelper(
  [Constants.COLLECTION_ACTION_EDIT],
  async ({ action, observer, store }) => {
    const { editUrl } = Selectors.getAdminUrlLinks({ ...store.value })
    window.location.href = editUrl
    observer.complete()
  }
)
export const exportEmailsCollectionEpic = observerEpicHelper(
  [Constants.COLLECTION_ACTION_EXPORT_EMAILS],
  async ({ action, observer, store }) => {
    const { exportEmailsUrl } = Selectors.getAdminUrlLinks({ ...store.value })
    window.location.href = exportEmailsUrl
    observer.complete()
  }
)
export const iosVirEpic = observerEpicHelper(
  [Constants.COLLECTION_ACTION_IOS_VIR],
  async ({ action, observer, store }) => {
    const { iosVirUrl } = Selectors.getAdminUrlLinks({ ...store.value })
    observer.next(ClipboardActions.COPY_TEXT(`${SITE_URL || ''}${iosVirUrl}`))
    observer.complete()
  }
)
export const reorderCollectionEpic = observerEpicHelper(
  [Constants.COLLECTION_ACTION_REORDER],
  async ({ action, observer, store }) => {
    const { reorderUrl } = Selectors.getAdminUrlLinks({ ...store.value })
    window.location.href = reorderUrl
    observer.complete()
  }
)
export default [
  createCollectionEpic,
  deleteCollectionEpic,
  duplicateCollectionEpic,
  editCollectionAction,
  exportEmailsCollectionEpic,
  iosVirEpic,
  reorderCollectionEpic,
]
